/* eslint-disable */
<template>

  <div>

    <vx-card>
      <company-form :companyForm="operation.client" title="Dados do cliente"/>
    </vx-card>

    <vx-card class="mt-4" :title="operation.idThunders.concat(' - ',operation.clientName)">
      <div>
        {{operation.portfolioDate | formatDate}}
      </div>
      <energy-balance-chart :values="values" bar-width="0.8"></energy-balance-chart>
    </vx-card>

    <vx-card class="mt-4">
      <div>
        <vs-table stripe :data="operationValues" noDataText="Nenhum registro encontrado.">

          <template slot="header">
            <h4>Balanço</h4>
          </template>

          <template slot="thead">
            <th class="text-center">Tipo da operação</th>
            <th class="text-center">Data início</th>
            <th class="text-center">Data fim</th>
            <th class="text-center">Preço</th>
            <th class="text-center">Quantidade MW/hora</th>
            <th class="text-center">Quantidade MW médio</th>
            <th class="text-center">Termo</th>
            <th class="text-center">Mercado</th>
            <th class="text-center">Tipo Energia</th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <td class="text-center">
                {{row.operationType | formatOperationType}}
              </td>
              <td class="text-center">
                {{row.startDate | formatDate}}
              </td>
              <td class="text-center">
                {{row.endDate | formatDate}}
              </td>
              <td class="text-center">
                {{row.price | toDecimal}}
              </td>
              <td class="text-center">
                {{row.qtdMwHour | toDecimal}}
              </td>
              <td class="text-center">
                {{row.qtdMwMed | toDecimal}}
              </td>
              <td class="text-center">
                {{row.term | formatTerm}}
              </td>
              <td class="text-center">
                {{row.market | formatMarket}}
              </td>
              <td class="text-center">
                {{row.energyType | formatEnergyType}}
              </td>
            </vs-tr>
          </template>

        </vs-table>
      </div>
    </vx-card>

    <div class="mt-4">
      <vs-button @click="$router.push('/')">Voltar</vs-button>
    </div>

  </div>

</template>

<script>

import axios from 'axios'
import EnergyBalanceChart from "@/components/stats/EnergyBalanceChart";
import CompanyForm from "@/components/CompanyForm";

export default {
  name: 'BalancoEnergeticoView',
  props: {
    guid: String
  },
  components:{
    EnergyBalanceChart,
    CompanyForm
  },
  data () {
    return {
      operation: {
        client: '',
        clientName: '',
        idThunders: '',
        portfolioDate: '',
        guarantor: ''
      },
      operationValues: [],
      values: {
        long: [],
        short: [],
        labels: [],
      },
    }
  },
  beforeMount () {
    this.load()
  },
  methods: {

    load () {

      axios.get(`${process.env.VUE_APP_API  }/api/v1/operation/${  this.guid}`)
        .then((response) => {
          this.operation = response.data
        })

      axios.get(`${process.env.VUE_APP_API  }/api/v1/operation-values/${  this.guid}`)
        .then((response) => {
          this.operationValues = response.data
        })

      axios.get(`${process.env.VUE_APP_API  }/api/v1/operation-values-chart/${  this.guid}`)
        .then((response) => {
          let short = response.data[0]
          let long = response.data[1]
          this.values.long = short.data
          this.values.short = long.data
          this.values.labels = short.categories

        })
    }

  }
}
</script>

<style scoped>

</style>
